import { ERROR_ALERT, SUCCESS_ALERT, WARNING_ALERT, CLOSE_ALERT } from '../actions/commonsActions';

const defaultState = {
	isOpen: false,
	alert: false
};

export const alert = (state = defaultState, action) => {
	switch (action.type) {
	case ERROR_ALERT:
		return {
			isOpen: true,
			alert: {
				status: action.alert.status,
				message: action.alert.message,
				comment: action.alert.comment
			}
		};

	case SUCCESS_ALERT:
		return {
			isOpen: true,
			alert: {
				status: action.alert.status,
				message: action.alert.message,
				comment: action.alert.comment
			}
		};

	case WARNING_ALERT:
		return {
			isOpen: true,
			alert: {
				status: action.alert.status,
				message: action.alert.message,
				comment: action.alert.comment
			}
		};

	case CLOSE_ALERT:
		return {
			isOpen: false,
			alert: false
		};

	default:
		return state;
	}
};



// WEBPACK FOOTER //
// ./src/reducers/alert.js